import { render, staticRenderFns } from "./UnderLink.vue?vue&type=template&id=0ad06d28&"
import script from "./UnderLink.vue?vue&type=script&lang=js&"
export * from "./UnderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports